import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { getCookie } from "./cookie";
var MethodsClass = /*#__PURE__*/function () {
  function MethodsClass() {
    _classCallCheck(this, MethodsClass);
    _defineProperty(this, "UA", void 0);
    _defineProperty(this, "isOpenHarmony", void 0);
    _defineProperty(this, "isIOS", void 0);
    _defineProperty(this, "isAndroid", void 0);
    _defineProperty(this, "isChrome", void 0);
    _defineProperty(this, "isSafari", void 0);
    _defineProperty(this, "regDicts", void 0);
    this.UA = typeof window === 'undefined' ? '' : window.navigator.userAgent.toLowerCase();
    this.isOpenHarmony = /openharmony/gi.test(this.UA) || /arkweb/i.test(this.UA);
    this.isIOS = /iphone|ipad|ipod|ios/gi.test(this.UA);
    this.isAndroid = /android/gi.test(this.UA);
    this.isChrome = /chrome/gi.test(this.UA);
    this.isSafari = /safari/gi.test(this.UA);
    this.regDicts = [{
      reg: '58zhuanzhuan',
      name: 'zz'
    }, {
      reg: 'zhaoliangji',
      name: 'zlj'
    }, {
      reg: 'hunter',
      name: 'hunter'
    }, {
      reg: 'zzupdoor',
      name: 'zzupdoor'
    }, {
      reg: 'miniprogram',
      name: 'mini'
    }];
  }
  _createClass(MethodsClass, [{
    key: "_getAjax",
    value: function _getAjax(action, param, callback) {
      var iosExecute = function iosExecute() {
        var iframe = document.createElement('iframe');
        iframe.style.width = '1px';
        iframe.style.height = '1px';
        iframe.style.display = 'none';
        param['methodName'] = action;
        var paramStr = JSON.stringify(param);
        iframe.src = "zznative://zhuanzhuan.hybrid.ios/?infos=".concat(encodeURIComponent(paramStr));
        document.body.appendChild(iframe);
        setTimeout(function () {
          return iframe.remove();
        }, 300);
      };
      var andrExecute = function andrExecute() {
        if (window.zhuanzhuanMApplication) {
          var oriParam = JSON.stringify(param);
          window.zhuanzhuanMApplication.executeCmd(action, oriParam);
        }
      };
      var harmonyExecute = function harmonyExecute() {
        try {
          var paramsObj = {
            name: action,
            data: param || null,
            callback: callback,
            protocolVersion: 'v1'
          };
          // console.log('hmos_bridge_servic', paramsObj)
          window.hmos_bridge_service.callNative(JSON.stringify(paramsObj));
        } catch (error) {
          // throw new Error('sdk日志----harmony执行错误action: ' + action, error)
        }
      };
      param['callback'] = this._getAjaxCallBack(callback);
      if (this.isOpenHarmony) {
        harmonyExecute();
        return;
      }
      if (this.isAndroid) {
        andrExecute();
      } else {
        iosExecute();
      }
    }

    /**
     * @function _getAjaxCallBack
     * @description 获取ajax回调
     * @param {function} callback
     * @return {string}
     * @private
     */
  }, {
    key: "_getAjaxCallBack",
    value: function _getAjaxCallBack(callback) {
      var callbackName = 'zzcallback_netWork';
      window[callbackName] = function (state, res) {
        if (state == '0') {
          callback(/^\{.*\}$/.test(res) ? JSON.parse(res) : res);
        } else {
          callback({
            code: 0,
            operatorType: '0',
            netWorkType: window.navigator.connection && window.navigator.connection.type || '0'
          });
        }
      };
      return callbackName;
    }

    /**
     * @function getOS
     * @description 获取系统及版本
     * @return {string}
     * @public
     */
  }, {
    key: "getOS",
    value: function getOS() {
      try {
        var result = '';
        if (this.UA) {
          if (this.isAndroid) {
            result = 'android';
          } else if (this.isIOS) {
            result = 'ios';
          } else if (this.isOpenHarmony) {
            result = 'HarmonyOS';
          } else {
            result = 'pc';
          }
        }
        return result;
      } catch (e) {
        return '';
      }
    }
  }, {
    key: "getOsVersion",
    value: function getOsVersion() {
      var u = navigator.userAgent,
        version = '';
      if (u.indexOf('Mac OS X') > -1) {
        // ios
        var regStr_saf = /OS [\d._]*/gi;
        var verinfo = u.match(regStr_saf);
        version = (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
      } else if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        // android
        version = u.substr(u.indexOf('Android') + 8, u.indexOf(';', u.indexOf('Android')) - u.indexOf('Android') - 8);
      } else {
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
          version = 'Windows XP';
        } else if (userAgent.indexOf('windows nt 6.0') > -1) {
          version = 'Windows Vista';
        } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
          version = 'Windows 7';
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
          version = 'Windows 8';
        } else if (userAgent.indexOf('windows nt 6.3') > -1) {
          version = 'Windows 8.1';
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
          version = 'Windows 10';
        } else {
          version = 'Unknown';
        }
      }
      return version;
    }

    /**
     * @function getNetType
     * @description 获取网络类型
     * @public
     */
  }, {
    key: "getNetType",
    value: function getNetType(callback) {
      this._getAjax('getNetworkTypeAndOperator', {}, this._getAjaxCallBack(callback));
    }

    /**
     * @function getPhoneType
     * @description 获取手机类型
     * @public
     */
  }, {
    key: "getPhoneType",
    value: function getPhoneType() {
      var phoneType = getCookie('model');
      return phoneType && phoneType != 'undefined' ? phoneType : '';
    }

    /**
     * @function getZZV
     * @description 获取转转app版本号
     * @public
     */
  }, {
    key: "getZZV",
    value: function getZZV() {
      var zzv = getCookie('v');
      var hv = getCookie('hv');
      if (~~(this.UA.indexOf('zzhunter') > 0)) {
        return hv && hv != 'undefined' ? hv : '';
      }
      return zzv && zzv != 'undefined' ? zzv : '';
    }

    /**
     * 版本号比较
     * @param {string} v1 版本号1，形如"2.2.3"
     * @param {string} v2 版本号2
     * @return {number} 比较结果，[-1 小于 | 0 等于 | 1 大于]
     */
  }, {
    key: "compareVersion",
    value: function compareVersion(v1, v2) {
      var seq1 = v1.split('.').map(function (subVersion) {
        return parseInt(subVersion);
      });
      var seq2 = v2.split('.').map(function (subVersion) {
        return parseInt(subVersion);
      });
      var len1 = seq1.length;
      var len2 = seq2.length;
      var commonLen = Math.min(len1, len2);
      for (var i = 0; i < commonLen; ++i) {
        if (seq1[i] != seq2[i]) return seq1[i] < seq2[i] ? -1 : 1;
      }
      return len1 == len2 ? 0 : len1 < len2 ? -1 : 1;
    }

    /**
     * @function isZZ
     * @description 是否端内
     * @public
     */
  }, {
    key: "isZZ",
    value: function isZZ() {
      return ~~(this.UA.indexOf('58zhuanzhuan') > 0);
    }
    /**
     * @function isZlj
     * @description 是否zlj
     * @public
     */
  }, {
    key: "isZlj",
    value: function isZlj() {
      return ~~(this.UA.indexOf('zhaoliangji-v2') > 0);
    }
    /**
     * @function isZZ
     * @description 是否采货侠
     * @public
     */
  }, {
    key: "isHunter",
    value: function isHunter() {
      return ~~(this.UA.indexOf('zzhunter') > 0);
    }
    /**
     * @function getUnique
     * @description 获取唯一标识符
     * @return {string} 唯一表示符
     * @public
     */
  }, {
    key: "getUnique",
    value: function getUnique() {
      var d = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
      return uuid;
    }
    /**
     * @function isDom
     * @description 判断dom节点
     * @return {boolean} true/false
     * @public
     */
  }, {
    key: "isDom",
    value: function isDom(obj) {
      if ((typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === 'object') {
        return obj instanceof HTMLElement;
      } else {
        return obj && _typeof(obj) === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string';
      }
    }
    // 获取平台类型
  }, {
    key: "getClientType",
    value: function getClientType() {
      var _iterator = _createForOfIteratorHelper(this.regDicts),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var regDict = _step.value;
          if (new RegExp(regDict.reg).test(this.UA)) {
            return regDict.name;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return 'other';
    }
    // 获取平台类型t值
  }, {
    key: "getZZT",
    value: function getZZT() {
      var zzt = getCookie('t');
      return zzt && zzt != 'undefined' ? zzt : '';
    }
    // 是否是预渲染页面
  }, {
    key: "isPrerenderPage",
    value: function isPrerenderPage() {
      //
      if (this.isAndroid) {
        return Number(typeof window.zzPreRender !== 'undefined');
      }
      //
      var isZzThan9_1_85 = this.compareVersion(this.getZZV(), '10.1.0') >= 0;
      if (this.isIOS && isZzThan9_1_85) {
        return Number(typeof window.zzPreRender !== 'undefined');
      }
      return 0;
    }
  }]);
  return MethodsClass;
}();
export default MethodsClass;
// export default MethodsClass